import React, { useState } from 'react'
import Styles from './UserTransactionsDownload.module.css'
import { Colors } from 'Theme'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { saveAs } from 'file-saver'
import { usersApiService } from 'Services/ApiService'
import CircularProgress from '@mui/material/CircularProgress'
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded'
import DoneIcon from '@mui/icons-material/Done'
import { toaster } from 'rsuite'
import { IFToastMessage } from 'Components'
import { CREATED } from 'Constants/HttpStatus'
import { encodeObjectToBase64 } from '../../Utils/Base64Functions'
import UserSelectors from 'Stores/User/Selectors'
import moment from 'moment'

const UserTransactionsDownload = ({ userTransactionsFilter, user }) => {
  const [progress, setProgress] = useState(0)
  const [getReport, setGetReport] = useState(false)
  const [pdfSuccess, setpdfSuccess] = useState(false)
  const [circularVariant, setCircularVariant] = useState('indeterminate')
  const [circularWidth, setCircularWidth] = useState(2)

  const animate = () => {
    setGetReport(!getReport)
    setTimeout(() => {
      setGetReport(false)
      animateDone()
    }, 500)
  }
  const animateDone = () => {
    setpdfSuccess(!pdfSuccess)
    setTimeout(() => {
      setpdfSuccess(false)
      setProgress(0)
      setCircularWidth(2)
      setCircularVariant('indeterminate')
    }, 1500)
  }
  const { t } = useTranslation()

  const getTransactionsReport = () => {
    setGetReport(true)
    let filter
    if (userTransactionsFilter != null) {
      filter = encodeObjectToBase64(userTransactionsFilter)
    }
    usersApiService({
      url: `/${user.id}/transactions/report`,
      method: 'POST',
      data: {
        filter: filter,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      responseType: 'blob', // important
      onDownloadProgress: (progressEvent) => {
        setCircularWidth(22)
        setCircularVariant('determinate')
        let percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total,
        )
        setProgress(percentCompleted)
        if (
          percentCompleted === 100 &&
          progressEvent.currentTarget.status === CREATED
        ) {
          animate()
        }
      },
    })
      .then((res) => {
        const excelBlob = new Blob([res.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })
        let currentTimestamp = moment().format('YYYY-MM-DDTHH꞉mm꞉ss')
        saveAs(excelBlob, `${user.name}_${currentTimestamp}_transactions.xlsx`)
      })
      .catch((err) => {
        setGetReport(false)
        setpdfSuccess(false)
        setProgress(0)
        setCircularWidth(2)
        setCircularVariant('indeterminate')
        toaster.push(
          <IFToastMessage
            type="error"
            text={err.message ? err.message : err.statusText}
          />,
        )
      })
  }
  return (
    <div className={Styles.wrapper}>
      <DoneIcon
        className={pdfSuccess ? Styles.loadingVisible : Styles.loadingHide}
        style={{ color: Colors.primary }}
      />
      <CircularProgress
        className={getReport ? Styles.loadingVisible : Styles.loadingHide}
        variant={circularVariant}
        value={progress}
        style={{ color: Colors.TransactionDownload }}
        size={30}
        thickness={circularWidth}
      />
      <div className={!getReport && !pdfSuccess ? Styles.visible : Styles.hide}>
        <div className={Styles.downloadIcon}>
          <DownloadRoundedIcon
            sx={{
              fontSize: '1.5rem',
              padding: 0,
              margin: 0,
              color: Colors.TransactionDownload,
            }}
            onClick={() => {
              getTransactionsReport('xlsx')
            }}
          />
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  userTransactionsFilter: UserSelectors.getTransactionsFilters(state),
  user: UserSelectors.getCurrentUser(state),
})

export default connect(mapStateToProps)(UserTransactionsDownload)
